<template>
    <div>
        <div v-for="formula in formulas" class="form-check mt-2">
            <input class="form-check-input"
                   @change="onChange"
                   type="radio"
                   :name="`calculation-formula-${extensionName}`"
                   :id="formula.key"
                   :value="formula.key"
                   :checked="formula.key === formulaKey"
                   :disabled="!extension || !checkIsAvailableFormula(formula.key)">
            <label v-tooltip="getFormulaHint(formula.key)"
                   v-html="formula.label"
                   :for="formula.key"
                   class="form-check-label clickable pt-1"
                   :class="{'text-muted': !checkIsAvailableFormula(formula.key)}">
            </label>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    name: 'CalculationFormulaSwitch',
    props: {
        extensionName: {
            type: String,
            required: true
        },
        formulas: {
            type: Array,
            required: true
        },
        formulaKey: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapGetters('doc_viewer_settings', [
            'settings',
            'extensions'
        ]),

        extension() {
            return this.extensions.find(e => e.name === this.extensionName)
        }
    },
    methods: {
        onChange(e) {
            this.$emit('update', e.target.value)
        },

        getLineFormulaInfo(formulaKey) {
            return this.formulas.find(f => formulaKey === f.key)
        },

        checkIsAvailableFormula(formulaKey) {
            const formula = this.getLineFormulaInfo(formulaKey)
            return formula && formula.available && typeof formula.available.validator === 'function'
                ? formula.available.validator(this.settings)
                : false
        },

        getFormulaHint(formulaKey) {
            if (this.extension && !this.checkIsAvailableFormula(formulaKey)) {
                return {
                    html: true,
                    content: '<div class="text-info">Available if</div>' + this.getLineFormulaInfo(formulaKey).available.hint
                }
            }
            return ''
        }
    }
}
</script>

<style scoped lang="scss">
</style>
